<template>
<div>
  <div class="title-h4 title-bar">{{title}}</div>
  <el-row type="flex" justify="space-between" class="title-bar">
    <div class="vertical-center-box">
      <span class="mr-r4">제어 스크립트 선택</span>
      <el-select class="mr-r4" size="mini" v-model="selectedScriptId" style="width:200px">
        <el-option v-for="item in ctrlScriptSetList" :key="item.scriptId" :label="item.scriptName" :value="item.scriptId"></el-option>
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-select>
      <el-button type="primary" class="mr-r4" @click="clickAddCtrlScript" :disabled="selectedScriptId == null">추가</el-button>
      <el-button size="mini" @click="onClickControlScript">제어 스크립트 관리</el-button>
    </div>
    <div>
      <el-button type="primary" @click="clickSaveButton" :disabled="!tableDataChangeFlag">저장</el-button>
      <el-button @click="clickCancelButton" :disabled="!tableDataChangeFlag">취소</el-button>
    </div>
  </el-row>
  <el-table :data="controlScriptTableData" style="width: 100%">
    <el-table-column type="expand">
      <template slot-scope="props">
          <div style="padding:15px; width: 100%;">
            {{props.row.scriptContents}}
          </div>
        </template>
    </el-table-column>
    <el-table-column label="스크립트" prop="scriptId">
    </el-table-column>
    <el-table-column label="순서" prop="orderbyIndex">
    </el-table-column>
    <el-table-column label="지연시간(분)" prop="delayTime">
      <template slot-scope="scope">
          <el-input-number v-model="scope.row.delayTime" controls-position="right" @change="changeTableData" :min="0" :max="5"/>
        </template>
    </el-table-column>
    <el-table-column prop="delayTime" width="80">
      <template slot-scope="scope">
          <i class="far fa-times c-pointer" @click="clickDeleteScript(scope.row)"></i>
        </template>
    </el-table-column>
  </el-table>
  <w-control-script-setting-popup ref="controlScriptPopup" :obj="obj" @reload="loadControlScriptListByManagetypeId"></w-control-script-setting-popup>
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import { isEmpty, isEqual, differenceWith, cloneDeep } from 'lodash';
import EventAlarmRuleSettingsAPI from '@/api/settings/common/event-alarm-rule-settings';
import WControlScriptSettingPopup from './ControlScriptSettingPopup';

export default {
  name: 'WControlScriptSetting',
  components: {
    WControlScriptSettingPopup,
  },
  props: {
    obj: {
      type: Object,
    },
    selectedEventAlarmRule: {
      type: Object,
    },
  },
  watch: {
    obj: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) {
          this.loadControlScriptListByManagetypeId();
        }
      },
    },
    selectedEventAlarmRule: {
      handler(value) {
        if (!isEmpty(value)) {
          this.title = `[${value.eventMessage}] 제어 스크립트 설정`;
          this.loadEventControlScriptData();
        }
      },
    },
  },
  data() {
    return {
      title: null,
      managetypeId: null,
      tableDataChangeFlag: false,
      ctrlScriptSetList: [],
      controlScriptTableData: [],
      controlScriptTableOriginData: [],
      selectedScriptId: null,
    };
  },
  methods: {
    /**
     * 이벤트에 설정된 제어 스크립트 목록을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadEventControlScriptData() {
      const params = {
        objId: this.selectedEventAlarmRule.objId,
        managetypeId: this.selectedEventAlarmRule.managetypeId,
        rsctypeId: this.selectedEventAlarmRule.rsctypeId,
        rscId: this.selectedEventAlarmRule.rscId,
        rsctypeKey: this.selectedEventAlarmRule.rsctypeKey,
        eventId: this.selectedEventAlarmRule.eventId,
      };
      this.loading = true;
      EventAlarmRuleSettingsAPI.getCtrlScriptSetListByEventAlarmRule(params)
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.controlScriptTableData = result;
            this.controlScriptTableOriginData = cloneDeep(result);
            this.tableDataChangeFlag = false;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '제어 스크립트 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '제어 스크립트 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 관리 구분 기준으로 제어 스크립트 목록을 조회한다.
     * @author Ju
     */
    loadControlScriptListByManagetypeId() {
      EventAlarmRuleSettingsAPI.getCtrlScriptSetListByManagetypeId({
        managetypeId: this.obj.objManagetypeId,
      })
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.ctrlScriptSetList = result;
            if (isEmpty(result)) {
              this.selectedScriptId = null;
            } else {
              this.selectedScriptId = result[0].scriptId;
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '제어 스크립트 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '제어 스크립트 정보', false));
          throw new Error(e);
        });
    },
    changeTableData() {
      this.tableDataChangeFlag = !isEqual(this.controlScriptTableData, this.controlScriptTableOriginData);
    },
    clickAddCtrlScript() {
      const selectedEventAlarmRule = this.selectedEventAlarmRule;
      const params = {
        objId: selectedEventAlarmRule.objId,
        managetypeId: selectedEventAlarmRule.managetypeId,
        rsctypeId: selectedEventAlarmRule.rsctypeId,
        rscId: selectedEventAlarmRule.rscId,
        rsctypeKey: selectedEventAlarmRule.rsctypeKey,
        eventId: selectedEventAlarmRule.eventId,
        scriptId: this.selectedScriptId,
      };
      EventAlarmRuleSettingsAPI.checkRuleObjEventSetScriptValidation(params).then((response) => {
        if (response.data.data) {
          let orderbyIndex;
          const tableData = this.controlScriptTableData;
          if (isEmpty(tableData)) {
            orderbyIndex = 0;
          } else {
            orderbyIndex = tableData[tableData.length - 1].orderbyIndex + 1;
          }
          params.orderbyIndex = orderbyIndex;
          params.delayTime = 0;

          const action = msgUtil.action.ADD;
          const target = '제어 스크립트';
          EventAlarmRuleSettingsAPI.insertRuleObjEventSetScript(params)
            .then((res) => {
              if (res.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.loadEventControlScriptData();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        } else {
          this.$message(msgUtil.getCustomMsgData('이미 존재하는 스크립트입니다.'));
        }
      });
    },
    clickDeleteScript(row) {
      const action = msgUtil.action.DELETE;
      const target = '제어 스크립트';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        EventAlarmRuleSettingsAPI.DeleteRuleObjEventSetScript(row)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadEventControlScriptData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
            throw new Error(e);
          });
      });
    },
    clickSaveButton() {
      EventAlarmRuleSettingsAPI.updateRuleObjEventSetScriptList(differenceWith(this.controlScriptTableData, this.controlScriptTableOriginData, isEqual)).then(() => {
        this.loadEventControlScriptData();
      });
    },
    clickCancelButton() {
      this.loadEventControlScriptData();
    },
    onClickControlScript() {
      this.$refs.controlScriptPopup.open();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ControlScriptSetting.vue